<template>
  <div class="card mb-4">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info">
            <p class="mb-0">
              جهت مشاهده لیست سفارشات ، پس از انتخاب فیلتر های مد نظر ، بر روی
              دکمه <i class="si si-magnifier"></i> کلیک کنید
            </p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>شماره همراه</label>
            <input
              type="tel"
              class="form-control"
              v-model="phone"
              v-mask="'09##-#######'"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>کد ملی</label>
            <input
              type="tel"
              class="form-control"
              v-model="nationalCode"
              v-mask="'##########'"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>کد رهگیری پستی</label>
            <input
              type="tel"
              class="form-control"
              v-model="postalTrackingCode"
              v-mask="'########################'"
            />
          </div>
        </div>
        <div class="col-md-3" v-if="$store.state.role == 'admin'">
          <label>دامنه</label>
          <Vselect
            v-model="domainId"
            :reduce="(item) => item.domainId"
            label="title"
            :options="domains"
          >
            <div slot="no-options">مقداری یافت نشد</div>
          </Vselect>
        </div>
        <div class="col-md-3" v-if="$store.state.role == 'admin'">
          <label>صادر کننده</label>
          <Vselect
            v-model="domainDataId"
            :reduce="(item) => item.domainDataId"
            label="name"
            :options="domainData"
            :disabled="!domainData.length"
          >
            <div slot="no-options">مقداری یافت نشد</div>
          </Vselect>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>نوع سفارش</label>
            <Vselect
              v-model="orderType"
              :reduce="(item) => item.orderTypeId"
              label="title"
              :options="orderTypes"
            >
              <div slot="no-options">مقداری یافت نشد</div>
            </Vselect>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>پروژه</label>
            <select class="form-control" v-model="projectId">
              <option
                v-for="(project, index) in projects"
                :value="project.id"
                :key="index"
                >{{ project.title }}</option
              >
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>طرح کارت</label>
            <select
              class="form-control"
              v-model="designTypeId"
              :disabled="!designTypes.length"
            >
              <option
                v-for="(designType, index) in designTypes"
                :value="designType.id"
                :key="index"
                >{{ designType.title }}</option
              >
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>وضعیت</label>
            <Vselect
              v-model="orderStatus"
              :reduce="(item) => item.flowStepStatusId"
              label="title"
              :options="flowStepStatusesId"
            >
              <div slot="no-options">مقداری یافت نشد</div>
            </Vselect>
          </div>
        </div>
        <div class="col-md-3">
          <label
            ><label style="color: red; height: 2px;">*</label> از تاریخ</label
          >
          <Datepicker
            simple
            auto-submit
            id="from-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :max="today"
            v-model="fromDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="col-md-3">
          <label
            ><label style="color: red; height: 2px;">*</label> تا تاریخ</label
          >
          <Datepicker
            simple
            auto-submit
            id="to-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :max="today"
            v-model="toDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
      </div>
      <div class="row" style="display: flex; justify-content: end">
        <div class="col-md-3">
          <button
            class="btn btn-primary w-100"
            style="margin-top:29px"
            @click="handleSearch"
            :disabled="fromDate == '' || toDate == ''"
          >
            <i class="si si-magnifier"></i>
            جستجو
          </button>
        </div>
      </div>
      <hr v-if="rows.length" />
      <div class="table-responsive mt-4" v-if="rows.length">
        <table class="table table-hover table-bordered">
          <thead>
            <tr>
              <th>شناسه سفارش</th>
              <th>نام و نام خانوادگی</th>
              <th>شماره همراه</th>
              <th>کد ملی</th>
              <th>نوع سفارش</th>
              <th>نام شعبه</th>
              <th v-if="$store.state.role == 'admin'">صادر کننده</th>
              <th>وضعیت</th>
              <th>تاریخ</th>
              <th>زمان</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in rows"
              @click="openOrder(row.order_id, row.order_type_id)"
              :key="index"
              style="cursor:pointer"
            >
              <td>{{ row.order_id }}</td>
              <td>{{ row.owner_first_name + " " + row.owner_last_name }}</td>
              <td>{{ row.owner_mobile }}</td>
              <td>{{ row.owner_national_code }}</td>
              <td>{{ row.order_type_title }}</td>
              <td>{{ row.branche_name }}</td>
              <td v-if="$store.state.role == 'admin'">
                {{ row.child_domain_data_title }}
              </td>
              <td>{{ row.flow_step_status_title }}</td>
              <td>
                {{
                  row.order_date.slice(0, 4) +
                    "-" +
                    row.order_date.slice(4, 6) +
                    "-" +
                    row.order_date.slice(6, 8)
                }}
              </td>
              <td>{{ row.order_time }}</td>
            </tr>
          </tbody>
        </table>
        <Pagination
          v-if="count > 10"
          :pages="pages"
          :currentPage="currentPage"
          :prevPageMethod="prevPage"
          :nextPageMethod="nextPage"
          :changePageMethod="changePage"
        />
        <span>تعداد کل ردیف ها : {{ count }} ردیف</span>
      </div>
      <div
        v-if="!rows.length && isSearched"
        class="alert alert-warning mt-2 mb-0"
      >
        <p class="mb-0">نتیجه ای یافت نشد</p>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "./Partials/Pagination";
import moment from "moment-jalaali";
export default {
  name: "Index",
  components: { Pagination },
  data() {
    return {
      showLoading: true,
      rows: [],
      currentPage: 1,
      count: 0,
      today: moment().format("jYYYY-jMM-jDD"),
      flowStepStatusesId: [],
      limit: 10,
      phone: "",
      nationalCode: "",
      postalTrackingCode: "",
      fromDate: "",
      toDate: "",
      orderTypes: [],
      orderType: "",
      orderStatus: "",
      domainId: "",
      domainDataId: "",
      domains: [],
      domainData: [],
      isSearched: false,
      pages: [],
      projects: [],
      projectId: 0,
      designTypes: [],
      designTypeId: 0,
    };
  },
  watch: {
    domainId(value) {
      this.domainData = [];
      this.domainDataId = "";
      if (value) this.getDomainData();
    },
    projectId(value) {
      if (value) this.getProjectTypes();
    },
  },
  methods: {
    changePage(e, page = null) {
      if (e) e.preventDefault();
      if (page) this.currentPage = page;
      this.getOrders();
    },
    nextPage(e) {
      if (e) e.preventDefault();
      this.currentPage = this.currentPage + 1;
      this.changePage();
    },
    prevPage(e) {
      if (e) e.preventDefault();
      this.currentPage = this.currentPage - 1;
      this.changePage();
    },
    getProjectTypes() {
      const projectId = this.projectId;
      this.$api
        .get("Project/GetDesignTypeByProjectId?ProjectId=" + projectId)
        .then(({ data }) => {
          if (data.status) this.designTypes = data.result;
        });
    },
    getBaseData() {
      this.$api.get("Orders/OrderType/Order").then(({ data }) => {
        this.orderTypes = data.result;
      });
      if (this.$store.state.role == "admin") {
        this.$api
          .post("User/GetDomain", {})
          .then(({ data }) => {
            this.domains = data.result;
          })
          .finally(() => {
            this.showLoading = false;
          });
      }
      this.$api
        .get("Flows/0")
        .then(({ data }) => {
          if (data.status) {
            let flowStepStatusesId = [];
            data.result.map((flowStep) => {
              flowStep.flowStepStatuses.map((flowStepStatus) => {
                if (
                  !flowStepStatusesId.find(
                    (flow) =>
                      flow.flowStepStatusId == flowStepStatus.flowStepStatusId,
                  )
                )
                  flowStepStatusesId.push({
                    flowStepStatusId: flowStepStatus.flowStepStatusId,
                    title: flowStepStatus.title,
                  });
              });
            });
            this.flowStepStatusesId = flowStepStatusesId;
          }
        })
        .finally(() => {
          if (this.$store.state.role != "admin") this.showLoading = false;
        });
    },
    getDomainData() {
      this.showLoading = true;
      this.$api
        .post("User/GetDomainData", { domainId: this.domainId })
        .then(({ data }) => {
          let domainData = [];
          data.result.map((item) => {
            domainData.push({
              domainDataId: item.domainDataId,
              name: item.fullName
                ? item.fullName
                : item.firstName + " " + item.lastName,
            });
          });
          this.domainData = domainData;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    getOrders() {
      this.showLoading = true;
      const finalPostedData = {
        p_fromdate: this.fromDate.replace(/\//g, ""),
        p_todate: this.toDate.replace(/\//g, ""),
        p_mobile: this.phone ? this.phone.replace("-", "") : null,
        p_nationalcode: this.nationalCode || null,
        p_tracking_post: this.postalTrackingCode || null,
        p_order_type: this.orderType ? parseInt(this.orderType) : null,
        p_flow_step_status_id: this.orderStatus
          ? parseInt(this.orderStatus)
          : null,
      };
      if (this.$store.state.role == "admin")
        finalPostedData.p_domain_data_id = this.domainDataId;
      if (this.designTypeId) finalPostedData.design_type_id = this.designTypeId;
      this.$api
        .post("Organizations/Bonus/Orders/Search/Org", {
          ...finalPostedData,
          p_limit: this.limit,
          p_offset: this.currentPage,
        })
        .then(({ data }) => {
          if (data.status && data.result) {
            this.rows = data.result.v_result || [];
            this.count = data.result.v_count
              ? data.result.v_count[0].cnt_total
              : 0;
            let calcPages = Math.ceil(
              (data.result.v_count && data.result.v_count[0].cnt_total
                ? data.result.v_count[0].cnt_total
                : this.limit) / this.limit,
            );
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          }
        })
        .finally(() => {
          this.showLoading = false;
          this.isSearched = true;
        });
    },
    openOrder(orderId, orderTypeId) {
      debugger;
      let routeData;
      switch (orderTypeId) {
        case 81:
          return null;
        case 101: // bonuscard
          routeData = this.$router.resolve({
            name: "bonusCards.single",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
        case 121: // foreign bonuscard
          routeData = this.$router.resolve({
            name: "foreignBonusCards.single",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
        case 2: // giftcard
          routeData = this.$router.resolve({
            name: "orders.show",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
        case 21: // pishkhan
          return null;
        case 1: // group sale
          routeData = this.$router.resolve({
            name: "orders.show",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
        case 61: // organization
          routeData =
            this.$store.state.role == "admin" ||
            this.$store.state.role == "finance"
              ? this.$router.resolve({
                  name: "orders.show",
                  params: { id: orderId },
                })
              : this.$router.resolve({
                  name: "organization.show",
                  params: { id: orderId },
                });
          return window.open(routeData.href, "_blank");
        case 141: // bank branches
          routeData = this.$router.resolve({
            name: "bankBranches.single",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
        case 143: // reissue
          routeData = this.$router.resolve({
            name: "bankBranches.single",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
        case 162: // reissue
          routeData = this.$router.resolve({
            name: "bankBranches.single",
            params: { id: orderId },
          });
          return window.open(routeData.href, "_blank");
      }
    },
    async handleSearch() {
      this.currentPage = 1;
      await this.getOrders();
    },
  },
  async created() {
    if (this.$store.state.role == "izbank-finance")
      return this.$router.push("/reports/transactions");
    await this.getBaseData();
    const urlParams = new URLSearchParams(window.location.search);
    this.$api.get("Project/GetAllProject").then(({ data }) => {
      if (data.status) this.projects = data.result;
    });
    if (urlParams.has("today")) {
      this.showLoading = true;
      this.fromDate = moment()
        .format("jYYYY-jMM-jDD")
        .replace(/-/g, "");
      this.toDate = moment()
        .format("jYYYY-jMM-jDD")
        .replace(/-/g, "");
      await this.handleSearch();
    }
  },
};
</script>
1
